/* File: activePlatform.jsx
 * Path: ananunadm/src/helpers/activePlatform.jsx
*/
import { useContext, createContext } from "react";

export const ActivePlatform = createContext();

export function useActivePlatform() {
	return useContext(ActivePlatform);
}
